// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dialog .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  max-height: 100% !important;
}

.dialogcontent-css {
  width: 100%;
}

.alinging-textbox {
  display: flex;
  width: 100% !important;
}

.alinging-textbox-two {
  display: flex;
  width: 100% !important;
}

.textfield {
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
}

.textfield-two {
  margin-right: 1rem !important;
  margin-top: 0.7rem !important;
}

.title-link {
  margin-left: 2rem;
  font-size: 25px !important;
}

.image {
  border: 2px solid #555;
}

.header-textfield {
  margin-left: 3rem !important;
  height: 1rem !important;
  margin-right: 2rem !important;
}

.main-heading {
  font-size: 25px !important;
  font-weight: 400 !important;
}

.main-heading-result {
  font-size: 25px !important;
  font-weight: 800;
}

.alert {
  width: 20%;
  position: fixed;
  top: 45%;
  right: 40%;
  left: 40%;
  bottom: 45%;
  z-index: 999;
  background-color: #0FC6EE !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 18px !important;
}

.image-box {
  border: 2px solid #555;
  width: 100%;
  height: 425px !important;
  text-align: center;
}
.image-box .image-text {
  line-height: 425px;
  font-size: 30px !important;
  font-weight: 600;
}

.alinging-textbox-for-edit {
  display: flex;
  width: 100% !important;
}
.alinging-textbox-for-edit .edit-all-select {
  display: flex;
  width: 50% !important;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-addStep {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-keyword {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-action {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-Options {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-select .edit-select-flow {
  width: 20% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield {
  display: flex;
  width: 50% !important;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-Wait {
  width: 10% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-Waittime {
  width: 10% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-pd {
  width: 30% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .textfield-type {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-img {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-BG {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}
.alinging-textbox-for-edit .edit-all-textfield .edit-textfield-threshold {
  width: 12.5% !important;
  margin-right: 1rem;
  margin-top: 0.25rem;
}

.modal-expand {
  margin-top: 1rem;
}

.stop-suite {
  width: 33%;
  height: 20%;
  position: fixed;
  top: 45%;
  right: 35%;
  left: 35%;
  bottom: 45%;
  z-index: 999;
  border: 4px black solid;
  background-color: rgb(195, 210, 235) !important;
  color: black !important;
  font-weight: 800 !important;
  font-size: 20px !important;
}

.results-mui ::-webkit-scrollbar {
  display: block;
  width: 0.5rem;
  height: 10px !important;
}
.results-mui ::-webkit-scrollbar-thumb {
  background-color: #0FC6EE;
  min-height: 10px !important;
}

.image-heading {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/TCTable/TCTable.style.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,6BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,iBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,4BAAA;EACA,uBAAA;EACA,6BAAA;AACJ;;AAEA;EACI,0BAAA;EACA,2BAAA;AACJ;;AAEA;EACI,0BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,UAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AACJ;;AAEA;EACI,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,0BAAA;EACA,gBAAA;AACR;;AAGA;EACI,aAAA;EACA,sBAAA;AAAJ;AAEI;EACI,aAAA;EACA,qBAAA;AAAR;AAEQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAJZ;AAQI;EACI,aAAA;EACA,qBAAA;AANR;AAQQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AANZ;AASQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AAPZ;AAUQ;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AARZ;AAUQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AARZ;AAUO;EACK,uBAAA;EACA,kBAAA;EACA,mBAAA;AARZ;AAUO;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AARX;AAUQ;EACI,uBAAA;EACA,kBAAA;EACA,mBAAA;AARZ;;AAaA;EACI,gBAAA;AAVJ;;AAaA;EACI,UAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,+CAAA;EACA,uBAAA;EACA,2BAAA;EACA,0BAAA;AAVJ;;AAcI;EACI,cAAA;EACA,aAAA;EACA,uBAAA;AAXR;AAcI;EACI,yBAAA;EACA,2BAAA;AAZR;;AAgBA;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAbJ","sourcesContent":[".custom-dialog .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    max-width: 100% !important;\n    max-height: 100% !important;\n}\n\n.dialogcontent-css {\n    width: 100%;\n}\n\n.alinging-textbox {\n    display: flex;\n    width: 100% !important;\n}\n\n.alinging-textbox-two {\n    display: flex;\n    width: 100% !important;\n}\n\n.textfield {\n    margin-right: 1rem !important;\n    margin-top: 0.7rem !important;\n}\n\n.textfield-two {\n    margin-right: 1rem !important;\n    margin-top: 0.7rem !important;\n}\n\n.title-link {\n    margin-left: 2rem;\n    font-size: 25px !important;\n}\n\n.image {\n    border: 2px solid #555\n}\n\n.header-textfield {\n    margin-left: 3rem !important;\n    height: 1rem !important;\n    margin-right: 2rem !important;\n}\n\n.main-heading {\n    font-size: 25px !important;\n    font-weight: 400 !important;\n}\n\n.main-heading-result {\n    font-size: 25px !important;\n    font-weight: 800;\n}\n\n.alert {\n    width: 20%;\n    position: fixed;\n    top: 45%;\n    right: 40%;\n    left: 40%;\n    bottom: 45%;\n    z-index: 999;\n    background-color: #0FC6EE !important;\n    color: black !important;\n    font-weight: 800 !important;\n    font-size: 18px !important;\n}\n\n.image-box {\n    border: 2px solid #555;\n    width: 100%;\n    height: 425px !important;\n    text-align: center;\n\n    .image-text {\n        line-height: 425px;\n        font-size: 30px !important;\n        font-weight: 600;\n    }\n}\n\n.alinging-textbox-for-edit {\n    display: flex;\n    width: 100% !important;\n\n    .edit-all-select {\n        display: flex;\n        width: 50% !important;\n\n        .edit-select-addStep {\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-select-keyword {\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-select-action {\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-select-Options {\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-select-flow {\n            width: 20% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n    }\n\n    .edit-all-textfield {\n        display: flex;\n        width: 50% !important;\n\n        .edit-textfield-Wait {\n            width: 10% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-textfield-Waittime {\n            width: 10% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;\n        }\n\n        .edit-textfield-pd{\n            width:30% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n        }\n        .textfield-type{\n            width:12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n        }\n       .edit-textfield-img{\n            width:12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem;   \n       }\n       .edit-textfield-BG{\n           width:12.5% !important;\n           margin-right: 1rem;\n           margin-top: 0.25rem;   \n       }\n        .edit-textfield-threshold{\n            width: 12.5% !important;\n            margin-right: 1rem;\n            margin-top: 0.25rem; \n        }\n    }\n}\n\n.modal-expand {\n    margin-top: 1rem;\n}\n\n.stop-suite {\n    width: 33%;\n    height: 20%;\n    position: fixed;\n    top: 45%;\n    right: 35%;\n    left: 35%;\n    bottom: 45%;\n    z-index: 999;\n    border: 4px black solid;\n    background-color: rgb(195, 210, 235) !important;\n    color: black !important;\n    font-weight: 800 !important;\n    font-size: 20px !important;\n}\n\n.results-mui {\n    ::-webkit-scrollbar {\n        display: block;\n        width: 0.5rem;\n        height: 10px !important; \n    }\n\n    ::-webkit-scrollbar-thumb {\n        background-color: #0FC6EE;\n        min-height: 10px !important;\n    }\n}\n\n.image-heading {\n    font-size: 18px;\n    font-weight: bold;\n    margin-bottom: 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
